import { render, staticRenderFns } from "./TournamentBracketView.vue?vue&type=template&id=07a88aed&scoped=true&"
import script from "./TournamentBracketView.vue?vue&type=script&lang=js&"
export * from "./TournamentBracketView.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBracketView.vue?vue&type=style&index=0&id=07a88aed&lang=scss&scoped=true&"
import style1 from "./TournamentBracketView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a88aed",
  null
  
)

export default component.exports